/* eslint-disable no-underscore-dangle */
import React from 'react'
import Pt from 'prop-types'

export default function Suggestion({
  s,
}) {
  return (
    <div>{s.formattedAddress}</div>
  )
}

Suggestion.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  s: Pt.object.isRequired,
}



// WEBPACK FOOTER //
// ./deps/internal-components/src/components/Form/AddressAutocomplete/Suggestion.jsx